import { useState } from 'react';

function useStateEnRango(valor, min, max) {
  var _useState = useState(valor),
      valorEnRango = _useState[0],
      setValorEnRango = _useState[1];

  function setter(v) {
    var valorEnRango = Math.max(min, Math.min(max, v)); // window.console.log('useStateEnRango -> setter', {valor, min, max, valorEnRango})

    setValorEnRango(valorEnRango);
  }

  return [valorEnRango, setter];
}

export default useStateEnRango;